import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {LeadaComponentsModule} from 'shared/components/leada-components.module';
import {DaytimeModule} from 'shared/daytime';

import {DialogsRepository} from './repositories/dialogs.repository';
import {DialogsService} from './services/dialogs.service';

import {DialogsCompletionPage} from './components/dialogs-completion-page/dialogs-completion-page';
import {DialogsDetailPage} from './components/dialogs-detail-page/dialogs-detail-page';
import {DialogsListPage} from './components/dialogs-list-page/dialogs-list-page';
import {DialogsQuestionsPage} from './components/dialogs-questions-page/dialogs-questions-page';

@NgModule({
    declarations: [
        DialogsListPage,
        DialogsDetailPage,
        DialogsQuestionsPage,
        DialogsCompletionPage,
    ],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild([
            { path: 'completion', component: DialogsCompletionPage },
            { path: 'detail', component: DialogsDetailPage },
            { path: 'list', component: DialogsListPage },
            { path: 'questions', component: DialogsQuestionsPage },
        ]),
        TranslateModule,
        DaytimeModule,
        LeadaComponentsModule,
    ],
    // entryComponents: [
    //     DialogsListPage,
    //     DialogsDetailPage,
    //     DialogsQuestionsPage,
    //     DialogsCompletionPage,
    // ],
    providers: [
        DialogsRepository,
        DialogsService,
    ],
})
export class DialogsModule { }
